/**
 * Where an invite link can open on vera.inc — the published pages (vera-website
 * lib/seo.ts PUBLIC_ROUTES and the industry slugs in content/industries.ts, as of
 * 2026-10-09). A picker convenience, NOT the rule: any path is accepted through "Other
 * path…", and the API is what decides (it refuses anything that is not a vera.inc path).
 * A staged page still opens for the visitor; it is just not offered here.
 */
export const OTHER_PATH = '__other'

const INDUSTRIES: Array<[string, string]> = [
  ['art', 'Art'],
  ['handbags', 'Handbags'],
  ['watches', 'Watches'],
  ['footwear', 'Footwear'],
  ['apparel', 'Apparel'],
  ['eyewear', 'Eyewear'],
  ['perfume', 'Cosmetics & Perfume'],
  ['wines-and-spirits', 'Wines & Spirits'],
  ['auction', 'Auction houses'],
  ['memorabilia', 'Memorabilia'],
  ['trading-cards', 'Trading Cards'],
  ['music', 'Music'],
  ['ticketing', 'Tickets & Memberships'],
]

const SOLUTIONS: Array<[string, string]> = [
  ['brand-protection', 'Brand protection'],
  ['resale-circularity', 'Resale & circularity'],
  ['consumer-engagement', 'Consumer engagement'],
  ['traceability-logistics', 'Traceability & logistics'],
  ['ai-analytics', 'AI & analytics'],
  ['sustainability-compliance', 'Sustainability & compliance'],
]

export const DESTINATION_OPTIONS: Array<{ value: string; label: string }> = [
  { value: '/', label: 'Home' },
  { value: '/tags', label: 'Tags' },
  { value: '/certificates', label: 'Certificates' },
  { value: '/platform', label: 'Platform' },
  { value: '/pricing', label: 'Pricing' },
  { value: '/roi-calculator', label: 'ROI calculator' },
  { value: '/industries', label: 'Industries' },
  ...INDUSTRIES.map(([slug, name]) => ({ value: `/industries/${slug}`, label: `Industries / ${name}` })),
  { value: '/solutions', label: 'Solutions' },
  ...SOLUTIONS.map(([slug, name]) => ({ value: `/solutions/${slug}`, label: `Solutions / ${name}` })),
  { value: '/compare', label: 'Compare' },
  { value: '/about', label: 'About' },
  { value: '/contact', label: 'Contact' },
  { value: OTHER_PATH, label: 'Other path…' },
]

/** The same first-pass rule as the API (tracked-links.rules.ts#validateDestination), for an inline error. */
export const destinationError = (path: string): string | null => {
  const s = path.trim()
  if (!s.startsWith('/') || s.startsWith('//')) return 'A path on vera.inc, starting with "/"'
  if (/[\s\\]/.test(s)) return 'A path cannot contain spaces or backslashes'
  if (s === '/invite' || s.startsWith('/invite/')) return 'Cannot point at another invite link'
  return null
}
